import * as z$1 from "zod/v4";
//#region src/schemas/daemon/windows-process-job.ts
const jobName = z$1.string().regex(/^Local\\OpenMeld-Process-[a-f0-9-]{36}$/u);
const text = z$1.string().min(1).refine((value) => !value.includes("\0"));
const windowsProcessJobRequestSchema = z$1.discriminatedUnion("operation", [z$1.strictObject({
	operation: z$1.literal("launch"),
	jobName,
	executable: text,
	commandLine: text.max(32766),
	workingDirectory: text,
	ownerPid: z$1.number().int().positive(),
	ownerStartedAt: z$1.string().regex(/^\d{10,20}$/u)
}), z$1.strictObject({
	operation: z$1.literal("drain"),
	jobName
})]);
//#endregion
export { windowsProcessJobRequestSchema };

//# sourceMappingURL=windows-process-job.js.map